import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';

/**
 * Hook to fetch crop propagation types
 * @returns {Object} All crop propagation types, loading state, and error
 */
export const useCropPropagationYypes = () => {
  const [cropPropagationYypes, setCropPropagationYypes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        // Fetch active schedule
        const { data: propagationTypeData, error: propagationTypeError } =
          await supabaseGetter.cropPropagationYypes.getAll();

        if (propagationTypeError) throw propagationTypeError;

        setCropPropagationYypes(propagationTypeData || null);
      } catch (err) {
        console.error('Error fetching crop propagation types data:', err);
        setError(err.message);
        setCropPropagationYypes(null);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  return {
    cropPropagationYypes,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.cropPropagationYypes.invalidate();
    }
  };
}
